export default "__VITE_ASSET__Vz8PGrCc__"